import React, { useEffect, useState } from 'react';
import '../../Document/InvoiceForm/InvoiceForm.scss';
import Purchase from '../../../../api/controllers/Financial/Purchase/Purchase';
import { formatError } from '../../../../utils/Formatters/Errors/formatError';
import DocumentEdit from '../../Document/DocumentEdit/DocumentEdit';
import { useParams } from 'react-router';

const PurchaseNoteEdit = () => {
  const { id } = useParams();
  const [error, setError] = useState();
  const [lineItems, setLineItems] = useState([]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const handleErrors = json => {
    loading && setLoading(false);
    const errorContent = formatError(json);
    const errorCount = errorContent.errors.length;
    setError({
      type: 'error',
      text: {
        errorTitle: `Action Failed, ${errorCount} error${errorCount > 1 ? 's' : ''} to resolve.`,
        errors: errorContent.errors,
      },
    });
  };

  useEffect(() => {
    Purchase.show(id).then(
      json => {
        setData(json);
        Purchase.lineItems({ entityId: json.entity.id, documentId: id }).then(
          json => {
            setLineItems(json.items);
            setLoading(false);
          },
          json => handleErrors(json),
        );
      },
      json => handleErrors(json),
    );
  }, []);

  return (
    <DocumentEdit
      formData={data}
      lineItems={lineItems}
      error={error}
      setError={setError}
      title={'Purchase Invoice'}
      index={'/financials/purchase_invoices/'}
      loading={loading}
    />
  );
};

PurchaseNoteEdit.propTypes = {};

export default PurchaseNoteEdit;
